import Hero from "@/components/Hero";
import BrandLogos from "@/components/BrandLogos";
import Services from "@/components/Services";
import ProblemsAndSolutions from "@/components/ProblemsAndSolutions";
import VideoShowcase from "@/components/VideoShowcase";
import VideoTestimonials from "@/components/VideoTestimonials";
import ClientFeedbacks from "@/components/ClientFeedbacks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Philosophy from "@/components/Philosophy";
import WebseitenShowcase from "@/components/WebseitenShowcase";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <main className="min-h-screen">
      <SEO 
        title="Videoproduktion Aachen & NRW | Imagefilm, Testimonials & KI-Videos | JC Productions"
        description="Professionelle Videoproduktion aus Aachen für ganz NRW: Imagefilme, Testimonials, Social Media Videos & KI-Produktionen. Mehr Kunden, mehr Sichtbarkeit, mehr Vertrauen. Jetzt anfragen!"
        canonical="/"
      />
      <Hero />
      <BrandLogos />
      <Philosophy />
      <Services />
      <ProblemsAndSolutions />
      <VideoShowcase />
      <WebseitenShowcase />
      <VideoTestimonials />
      <ClientFeedbacks />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
